export default "__VITE_ASSET__DZ0$y5aM__"